(function() {
    "use strict";

    function Newsletter() {
        var global = {
            forms: jQuery('form[name=newsletter-form], form[name=newsletter-sign-up-form]')
        };

        var fn = {
            init: function() {
                if (global.forms.length === 0) {
                    return;
                }
                
                global.forms.each(function() {
                    var form = jQuery(this);
                    form.on('submit', fn.subscribeToNewsletter);
                    form.on('keyup', fn.clearFormErrors);
                });
            },
            
            clearFormErrors: function(e) {
                var form = jQuery(e.target).closest('form');
                form.find('.text-field').removeClass('has-error');
                form.find('.form-elements--error').text('');
            },
            
            subscribeToNewsletter: function(e) {
                e.preventDefault();
                var form = jQuery(this);

                // Disable submit button until there's a response
                form.find('button[type=submit]').attr('disabled', true);
                
                jQuery.ajax({
                    type: 'post',
                    url: baatajax.rest_endpoint + 'baat/v1/subscribe/',
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader('X-WP-Nonce', baatajax.rest_nonce);
                    },
                    contentType: 'application/json; charset=UTF-8',
                    data: JSON.stringify({
                        firstname: form.find('input[name^=newsletter_firstname]').val(),
                        lastname: form.find('input[name^=newsletter_lastname]').val(),
                        email: form.find('input[name^=newsletter_email]').val(),
                        'cf-turnstile-response': window.turnstileToken,
                    })
                }).done(function(response) {
                    if (!response) {
                        return;
                    }
                    
                    form.find('button[type=submit]').removeAttr('disabled');
                    
                    form.find('input[name^=newsletter_firstname]').val('');
                    form.find('input[name^=newsletter_lastname]').val('');
                    form.find('input[name^=newsletter_email]').val('');
                    
                    form.find('.footer-form__elements, .sign-up-form__elements').hide();
                    form.find('.footer-form__elements--feedback, .newsletter-sign-up-form__elements--feedback').show().text('Subscribed! Please check your email for further instructions.');
                    if (form.attr('name') === 'newsletter-sign-up-form') {
                        jQuery('.newsletter-sign-up-form__elements').remove();
                        jQuery('.newsletter-sign-up-form__actions').remove();
                    }
                }).fail(function(response) {
                    console.log(response);
                    form.find('button[type=submit]').removeAttr('disabled');
                    
                    const error = response.responseJSON;
                    
                    if (response && response.responseJSON && error.data.params) {
                        const field = Object.keys(error.data.params)[0];
                        const fieldEl = form.find('input[name=newsletter_' + field + ']');
                        
                        fieldEl.parent('.text-field').addClass('has-error');
                        fieldEl.closest('.form-elements').find('.form-elements--error').text('Please check the value for this field');
                    } else {
                        fn.addGeneralFeedback(form);
                    }

                    const isTurnstileError = error.data && error.data.params && error.data.params['cf-turnstile-response'];
                    if (isTurnstileError) {
                        fn.addGeneralFeedback(form);
                    }
                });
            },

            addGeneralFeedback: function(form) {
                form.find('span[name=general_feedback]').removeAttr('hidden').text('Sorry, something went wrong. Please try again later.');
            }
        };

        jQuery(fn.init);
    }

    new Newsletter();
})();
